export class MarkerLayers {
    static unitPosition(
        id,
        circleRadius,
        color,
        circleBorder,
        borderColor,
        shadowRadius,
        shadowColor,
        textSize,
        textColor,
        textShadowSize,
        textShadowColor
    ) {
        let layers = [];

        layers.push({
            id: `${id}-outer-circle`,
            type: 'circle',
            layout: {},
            paint: {
                'circle-radius': shadowRadius,
                'circle-color': shadowColor,
                'circle-stroke-width': 0,
            },
        });

        layers.push({
            id: `${id}-inner-circle`,
            type: 'circle',
            layout: {},
            paint: {
                'circle-radius': circleRadius,
                'circle-color': color,
                'circle-stroke-width': circleBorder,
                'circle-stroke-color': borderColor,
            },
        });

        layers.push({
            id: `${id}-text`,
            type: 'symbol',
            layout: {
                'text-field': ['get', 'label'],
                'text-anchor': 'center',
                'text-offset': [0, -2],
                'text-allow-overlap': true,
                'text-max-width': 30,
                'text-size': textSize,
            },
            paint: {
                'text-color': textColor,
                'text-halo-color': textShadowColor,
                'text-halo-width': textShadowSize,
            },
        });

        return layers;
    }
}
